export enum DispoEmploymentTabIdEnum {
  OPEN = 'OPEN',
  BOOKED = 'BOOKED',
  ARCHIVED = 'ARCHIVED',
}
